<div class="app-fast-access-entry-container" (click)="openFastAccessEntry()">
  @if (fastAccessDescription.icon && fastAccessDescription.icon.iconName) {
    <claas-icon
      [iconName]="fastAccessDescription.icon.iconName"
      [iconId]="fastAccessDescription.icon.iconId ?? ''"
      [namespace]="fastAccessDescription.icon.namespace ?? ''"
      [size]="fastAccessDescription.icon.size ?? 24"
      [iconStyle]="fastAccessDescription.icon.style ?? 'bold'">
    </claas-icon>
  } @else {
    <img [src]="fastAccessDescription.iconImg" />
  }

  <span class="text-sm !pl-4" data-testid="fast-access-title">
    {{ fastAccessDescription.name | translate }}
  </span>

  @if (fastAccessDescription.outsideLink) {
    <claas-icon class="outside-link" iconId="747620" namespace="cc" [size]="20"> </claas-icon>
  }
</div>
